<div class="animated fadeIn">

  <div class="container-vertical-padding-half">
    <app-customer-record-owner-user-list
      [customerId]="customerId"
      [customerRecordId]="customerRecordId"
      [rightModel]="rightModel"
      [readonly]="readonly">
    </app-customer-record-owner-user-list>
  </div>
  <div class="container-vertical-padding-half">
    <app-customer-record-owner-group-list
      [customerId]="customerId"
      [customerRecordId]="customerRecordId"
      [rightModel]="rightModel"
      [readonly]="readonly">
    </app-customer-record-owner-group-list>
  </div>

</div>
